import { SvgIcon, SvgIconProps } from '@mui/material';

/** @deprecated Use theme-next icons or move into theme-next folder if it doesn't exists */
export const ExtranetIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 20 20" {...props}>
            <path
                fill="none"
                d="M13 3.5H2V13.5H13V3.5Z"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M18 10.5H13V13.5H18V10.5Z" fill={props.htmlColor || '#21272E'} />
            <path
                d="M13 7.5H15.8571L18 9.75V13.5H13V7.5Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M5.5 16.5C6.32843 16.5 7 15.8284 7 15C7 14.1716 6.32843 13.5 5.5 13.5C4.67157 13.5 4 14.1716 4 15C4 15.8284 4.67157 16.5 5.5 16.5Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.5 16.5C16.3284 16.5 17 15.8284 17 15C17 14.1716 16.3284 13.5 15.5 13.5C14.6716 13.5 14 14.1716 14 15C14 15.8284 14.6716 16.5 15.5 16.5Z"
                fill="none"
                stroke={props.htmlColor || '#21272E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
